module.exports = __webpack_public_path__ + "img/HeaderB.29df94ac.png";